import React from "react";
import { Typography } from "@mui/material";
import TranslationContent from "../../../../Translations/TranslationContent";


const NoMatchWithDataType = () => {
  return <Typography sx={{color: "black"}} variant="body2"><TranslationContent contentID="noMatchWithDataTypeDesc" /></Typography>
}

export default NoMatchWithDataType;